var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { ReactComponent as CloseIcon } from '../../../assets/images/close.svg';
import { DynamicFormBuilderContainer } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container';
import { FormItemTypes } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
import { SavedFilterAPI } from '../services/apiCalls';
var SaveFilterPopUp = function (_ref) {
    var data = _ref.data, onClose = _ref.onClose;
    console.log('Data Pass Succesfully -- 0909--', data);
    var formData = [{
            type: FormItemTypes.Box,
            name: '',
            padding: '24px 24px 0px',
            columnSize: 12,
            // spacing: 0,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            elements: [{
                    type: FormItemTypes.Typography,
                    name: '',
                    children: 'Save filters',
                    columnSize: 0,
                    fontSize: 'xxl',
                    fontWeight: 'strong'
                }, {
                    type: FormItemTypes.IconButton,
                    name: '',
                    children: /*#__PURE__*/ React.createElement(CloseIcon, {
                        color: "secondary[600]",
                        height: '20px',
                        width: '20px'
                    }),
                    columnSize: 0,
                    onClick: function () {
                        onClose();
                    }
                }]
        }, {
            type: FormItemTypes.Box,
            name: '',
            label: '',
            value: null,
            columnSize: 12,
            gap: 2,
            p: '16px 24px',
            elements: [{
                    type: FormItemTypes.TextInput,
                    name: 'Name',
                    label: 'Filter name',
                    columnSize: 12
                }]
        }, {
            type: FormItemTypes.Divider,
            name: 'Divider',
            variant: 'fullWidth',
            columnSize: 12
        }, {
            type: FormItemTypes.Box,
            name: '',
            label: '',
            value: null,
            columnSize: 12,
            gap: 1.5,
            p: '21px 24px 20px',
            display: 'flex',
            justifyContent: 'end',
            elements: [{
                    type: FormItemTypes.Button,
                    name: '',
                    children: 'Cancel',
                    variant: 'outlined',
                    columnSize: 0,
                    color: 'secondary',
                    onClick: function () {
                        onClose();
                    }
                }, {
                    type: FormItemTypes.Button,
                    name: '',
                    children: 'Save',
                    variant: 'contained',
                    columnSize: 0,
                    setFormState: function (formValues) {
                        SavedFilterAPI({
                            request: {
                                Name: formValues === null || formValues === void 0 ? void 0 : formValues.Name,
                                Key: "PDICheck",
                                Value: {
                                    InspectorId: data === null || data === void 0 ? void 0 : data.InspectorId,
                                    TechnicianId: data === null || data === void 0 ? void 0 : data.TechnicianId,
                                    VehicleModel: data === null || data === void 0 ? void 0 : data.VehicleModel,
                                    StartDate: data === null || data === void 0 ? void 0 : data.StartDate,
                                    EndtDate: data === null || data === void 0 ? void 0 : data.EndtDate,
                                    Branch: data === null || data === void 0 ? void 0 : data.Branch
                                },
                                SetDefault: true
                            }
                        });
                        return {};
                    },
                    setFieldProps: function (formValues, currValue, field, formApi) {
                        console.log('filter Log--', formValues);
                        return {
                            disabled: (formValues === null || formValues === void 0 ? void 0 : formValues.Name) == undefined || (formValues === null || formValues === void 0 ? void 0 : formValues.Name) == null || '' ? true : false
                        };
                    },
                    onClick: function () {
                        onClose();
                    }
                }]
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        getFormAPI: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, ({
                        data: data,
                        success: true
                    })];
            });
        }); }
    }));
};
export default SaveFilterPopUp;
